<template>
  <div class="box">
    <div class="boxLeft" :style="{width: OneBoxShow === true ?'96%' : '70%'}">
      <div class="leftSc">
        <div class="bjq">
          <div class="btinp">
            <input type="text" v-model="WZtitle" placeholder="文章标题" maxlength="30"
                   style="width: 90%;height: 50px;text-align:left;border: none;margin: 10px 0;">
            <span class="titnum">{{titNum}}<span>/30</span></span>
          </div>
          <!--        <quill class="quill" @getData="getData" :contents="content"></quill>-->
          <!--        <div style="padding-bottom: 100px;">-->
          <quill class="quill"
                 @getData="getData"
                 :rangenum="rangenum"
                 :yinY="yinY"

                 :upActive="upActive"
                 :contents="content"></quill>
          <!--        </div>-->
          <div
            style="width: 100%;text-align: center;color: #333;padding-top: 8px;font-size: 14px;position: absolute;bottom: -25px;background-color: #fff;height: 40px;z-index: 100;"><span
            style="font-weight: bold;font-size: 16px;">{{conNum}}</span>个字
          </div>

          <div class="caoz">
            <!--<div class="save" @click="outDrBox = true">导入</div>-->
            <div class="save flex align-center padding-left" @click="save()"> <img src="../../../assets/images/saveIcon.png" alt="" class="margin-right-xs">保存</div>
            <div class="shengC flex align-center padding-left" @click="save('999')"><img src="../../../assets/images/save-img.png" alt="" class="margin-right-xs">{{saveTex}}</div>
            <!--<div v-show="mbId" class="shengC" @click="save('888')">保存模板</div>-->
            <!--          <div class="cpoy">一键复制</div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="boxRight" :class="rightTrue === true ? 'fixd' : ''"
         :style="{width: OneBoxShow === true  ?'4%' : '30%'}">
      <!--      -->
      <div class="wjz" v-show="OneBoxShow">
        <div style="cursor: pointer;" @click="jSou">
          <img src="../../../assets/images/sucaiIcon.png" alt="">
          <div class="tex">素材</div>
        </div>

      </div>

      <!--      -->
      <div class="rBox" v-show="TwoBoxShow">
        <h3>请告诉益书宝您想写什么？</h3>
        <div class="inp">
          <input type="text" v-model="search" placeholder="请输入关键字">
        </div>
        <div class="souS">
          <button @click="jSou">搜索</button>
        </div>
      </div>

      <!--      -->
      <div class="tBox" v-show="ThreeBoxShow">
        <div class="tBoxTop">
          <div class="ssBtn flex align-center justify-center" @click="SousWZlist">
            <img src="../../../assets/images/souS.png" alt="">搜索
          </div>
          <input type="text" v-model="search" placeholder="请输入关键字">
          <button @click="outDrBox = true">+导入文章到编辑区</button>
        </div>
        <div class="biaoQ" v-if="hasBiaoq" style="border-bottom: none;">

          <div class="biaoQ">
            <span class="s1">标签:</span>
            <span class="s2" :class="souSlable === '' ? 'bqact' : ''" @click="souSlable = ''">全部</span>
            <span class="s2" v-for="item in AllBiaoqList" :key="item.id" @click="souSlable = item.title"
                  :class="souSlable === item.title ? 'bqact' : ''">{{item.title}}</span>
          </div>
<!--          <div v-else class="biaoQ">-->
<!--            <span class="s1">标签:</span>-->
<!--            <span class="s2 bqact" v-for="item in AllBiaoqList" :key="item.id">{{item.title}}</span>-->
<!--          </div>-->

        </div>
        <div class="WzBox" v-if="hassucaiList">
          <div class="wenZ" v-for="item in WzList" :key="item.id">
            <p style="margin-left: 46px; padding: 10px 0;font-size: 16px; margin-right: 22px;font-weight: bold;border-bottom: 1px solid rgb(153, 153, 153); overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</p>
            <div class="wzTop">
              <div class="wzTopLeft" style="margin-top: 65px;">
                <span @click="add(item.content,item.id,item.type)" style="cursor: pointer;">
                  <img src="../../../assets/images/yinyongIcon.png" alt="">
                  <div>引用</div>
                </span>
                <span @click="yl(item.id,item.type)" style="cursor: pointer;margin-top: 20px;">
                  <img src="../../../assets/images/aqaq.png"
                       style="width: 20px;height: 20px;position: relative;top: 5px;margin-top: 20px;" alt="">
                  <div>预览</div>
                </span>

              </div>
              <div class="wzTopRight">
                <div v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn" @click="chu" v-show="OneBoxShow">
        〈
      </div>
      <div class="btnTwo" @click="shou" v-show="!OneBoxShow">
        〉
      </div>
    </div>
    <!--  保存弹框  -->
    <el-dialog
      :title="tanTit"
      :visible.sync="dialogVisible"
      width="720px"
      append-to-body
      custom-class="saveBox"
      center>
      <div class="">
        <div class="conit">
          <el-form ref="form" :model="sizeForm" label-width="100px" size="medium">
            <div style="width: 100%;display: flex;justify-content: space-between;">
              <el-form-item label="选择文件夹" v-show="shengC === '999'? false : true" style="flex:1;">
                <el-select v-model="sizeForm.region" placeholder="点击选择预存储到的文件夹" style="width: 100%;">
                  <el-option v-for="(item,index) in wjList" :key="index" :label="item.foldername"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <!--<el-form-item style="margin-left: 10px;width: 100px;" label="" >-->
              <div class="xj" @click="xj" style="margin-left: 30px;" v-show="shengC === '999'? false : true"><span></span> 新建文件夹</div>
              <!--</el-form-item>-->
            </div>
            <el-form-item label="">
              <div class="yxBq">点击 <span
                style="display: inline-block;width: 15px;height: 15px;background-color: #0a2240;text-align: center;line-height: 13px;border-radius: 7px;color: #ffffff;">+</span>从标签库选择文章标签
              </div>
              <div class="yxBox">
                <div class="mbBq" style="background-color: #d9d9d9;" v-for="item in suoYbiaoQList"
                     :key="item.id">
                  {{item.title}}
                  <div class="jia" style="background-color: #0a2240;"
                       @click="addBq(item.id, item.title)">
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="">
              <div class="yxBq">已选标签</div>
              <div class="yxBox">
                <div class="mbBq" v-for="(item , index) in XuanZbiaoQList" :key="index">
                  {{item.title}}
                  <div class="jiaA" @click="delBq(item.id,index)"></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="添加新标签">
              <el-input v-model="sizeForm.name" style="display: inline-block;width: 78%;"
                        placeholder="标签库没有满足的标签，在此处输入您预设置的新标签" placeholder-style="font-size: 12px;"></el-input>
              <el-button @click="tjBq"
                         style="width: 90px;margin-left: 12px;display: inline-block;background-color: #0a2240;color: #fff;border: none;">
                添加
              </el-button>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary"
                   style="width: 100px;height: 36px;border-radius: 18px;background-color: #0a2240;color: #fff;border: none;"
                   v-show="shengC !== '999' && mbIdBool === false" @click="qdSave">保存</el-button>
         <el-button type="primary"
                    style="width: 100px;height: 36px;border-radius: 18px;background-color: #0a2240;color: #fff;border: none;"
                    v-show="shengC !== '999' && mbIdBool === true" @click="qdSave">保存</el-button>
        <el-button type="primary"
                   style="width: 100px;height: 36px;border-radius: 18px;background-color: #0a2240;color: #fff;border: none;"
                   v-show="shengC === '999' && mbIdBool === false" @click="shengMuabn">保存</el-button>
         <el-button type="primary"
                    style="width: 100px;height: 36px;border-radius: 18px;background-color: #0a2240;color: #fff;border: none;"
                    v-if="mbIdBool === true && shengC === '999'" @click="editMuabn">确定</el-button>
         <el-button @click="quXsave"
                    style="width: 100px;height: 36px;border-radius: 18px;background-color: #99a2aa;color: #333;">取 消</el-button>
      </span>
    </el-dialog>
    <!--  预览弹框  -->
    <el-dialog
      :visible.sync="status"
      custom-class="muXqDEtail"
      :modal-append-to-body="false"
      :show-close="false">
      <div class="title" v-html="ylWZtitle"></div>
      <div class="conte" v-html="ylcontent"></div>
      <div class="btn">
        <div class="qdBtn" @click="add(ylcontent,ylID)">引用</div>
        <div class="qXBtn" @click="colse">取消</div>
      </div>
    </el-dialog>
    <!--  保存模板成功  -->
    <el-dialog
      title="温馨提示"
      :visible.sync="mubanAdd"
      width="30%"
      :show-close="false"
      center
      :append-to-body="true"
      custom-class="addMUbAN"
    >
      <div style="width: 100%;text-align:center;color: #666;">本文已保存到自有模板中</div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="toMuban"
               style="width: 100px;border:none; height:36px;border-radius: 18px;background-color: #0a2240;color: #fff;">确 定</el-button>
  </span>
    </el-dialog>
    <!--  保存文章成功  -->
    <el-dialog
      title="温馨提示"
      :visible.sync="wenzhangAdd"
      width="30%"
      :show-close="false"
      center
      :append-to-body="true"
      custom-class="addMUbAN"
    >
      <div style="width: 100%;text-align:center;color: #666;">本文已保存到我的文章中</div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="toWenzhang"
               style="width: 100px;border:none; height:36px;border-radius: 18px;background-color: #0a2240;color: #fff;">确 定</el-button>
  </span>
    </el-dialog>
    <!--  导入  -->
    <el-dialog title="导入编辑"
               :visible.sync="outDrBox"
               :modal-append-to-body="true"
               :append-to-body="true"
               custom-class="drMUbAN"
    >
      <div class="drXz">
        <el-upload
          class="upload-demo"
          action=""
          :before-upload="handleChange"
          :limit="drNum"
          :show-file-list="false"
        >
          <img class="img" src="../../../assets/images/bddr_03.png" alt="" style="margin-bottom: 50px;">
        </el-upload>
        <img class="img" src="../../../assets/images/zskdr_03.png" alt="" @click="innerDrBox = true">
      </div>

      <el-dialog
        width="30%"
        title="导入编辑"
        :visible.sync="innerDrBox"
        :append-to-body="true"
        custom-class="drMUbANTwo"
      >
        <div class="zskBoxTwo">
          <div class="title">选择要导入的文件</div>
          <div class="listBox">
            <div class="scrollBox">
              <el-tree
                :data="zsgl"
                :props="props"
                ref="treeZsk"
                node-key="id"
                show-checkbox
                :check-strictly="true"
                @check-change="handleCheckChange">
              </el-tree>
            </div>

          </div>

        </div>
        <div class="zskbtn" @click="qued">
          确定
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
  import quill from '../../../components/quill'

  export default {
    name: "zncgBanKuai",
    data() {
      return {
        tanTit: '文章保存', //  保存弹框标题
        rightTrue: false, // 右边栏加样式
        statesave: false,
        mbIdBool: false, // 模板ID是否存在
        yinY: 1,
        search: '',
        guanjianzi: '',
        wenzhangAdd: false,
        mubanAdd: false,
        status: false,
        ylID: '', // 预览文章id
        id: null, // 编辑的文章id
        mbId: null, // 编辑自有模板Id
        shengchengWZ: null, //
        shengC: '',
        saveTex: '生成模板',
        flag: false,
        timer: null,
        count: '',
        hasBiaoq: true, //  该篇文章是否有标签
        hassucaiList: true, //  是否有相关素材
        isId: true, //  是否 有文章 或者模板  ID  控制全部标签显示隐藏
        titNum: '0', // 标题字数显示
        conNum: '0', // 文章显示字数
        WZtitle: '', // 文章标题
        ylWZtitle: '', // 预览文章标题
        suoYbiaoQList: [], //
        wjList: [], // 文件夹列表
        dialogVisible: false, // 保存弹框
        OneBoxShow: false,
        TwoBoxShow: true,
        ThreeBoxShow: false,
        content: '', // 编辑器内容
        ylcontent: '', // 预览内容
        ylType: '', // 预览内容
        XuanZbiaoQList: [], // 选中的标签列表
        XuanZbiaoQianTexList: [],  // 选中标签文字列表
        XuanZbiaoQianIDList: [],  // 选中标签ID列表
        WzList: [], // 搜索出来的文章列表
        AllBiaoqList: [], // 所有标签列表
        souSlable: '', // 搜索标签
        sizeForm: {
          name: '',
          region: ''
        },
        rangenum: '',
        outDrBox: false, // 外部导入框
        innerDrBox: false, // nei部导入框
        drNum: 1,
        props: {    // 知识库树渲染字段
          label: 'label',
          children: 'folder_info'
        },
        zsgl: [],  //  知识库树
        zskid: '', // 知识库文章id
        upActive:false,
        wenB: '', // 本地导入文本
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    mounted() {
      window.addEventListener('scroll', this.getScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.getScroll);
    },
    created() {
      if (!this.user) {
        this.$router.push("/login")
      }
      // 判断首页直接搜智能成稿进来的关键字
      var zhiJieS = this.$router.history.current.query.zhiJieS
      if (zhiJieS) {
        this.OneBoxShow = false
        this.TwoBoxShow = false
        this.ThreeBoxShow = true
        this.search = zhiJieS
        this.SousWZlist()
      }
      this.id = this.$router.history.current.query.id
      this.shengchengWZ = this.$router.history.current.query.shengchengWZ
      this.mbId = this.$route.query.bjid
      this.mbIdBool = Boolean(this.mbId)
      if (this.id && this.shengchengWZ !== '98') {
        //  获取详情
        this.Viemoban(this.id)
        this.saveTex = '生成模板'
      }
      if (this.mbId) {
        //  获取详情
        this.Viemoban(this.mbId)
        this.saveTex = '保存模板'
      }
      if (this.id && this.shengchengWZ === '98') {
        //  获取自己写的文章详情
        this.viewArticle()
      }
      if (!this.id) {
        //   获取所有标签
        this.AllLableList()
      } else {
        this.isId = false
      }
      if (!this.mbId) {
        //   获取所有标签
        this.AllLableList()
      } else {
        this.isId = false
      }
      this.$emit('setIsAct', 3)
      // 获取我所有标签接口
      this.getMeSuoYBiaoq()
      // 文件夹列表
      this.GetwjList()
      // 获取库和树
      this.getKu()
    },
    methods: {
      // 知识库导入文件
      qued() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var ary = this.$refs.treeZsk.getCheckedNodes();
        this.$api.apiAdmin.wordread({
          path: ary[0].filepath
        }).then(res => {
          this.content = this.content.replace(/body/g, "div") + res.replace(/body/g, "div")
          this.innerDrBox = false
          this.outDrBox = false
          loading.close();
        }).catch(res => {
          loading.close();
         this.$message.error(res.msg)
          this.upActive = true
          this.status = false
          this.innerDrBox = false
          this.outDrBox = false
          this.content = this.content + res.replace(/body/g, "div")


        })
      },

      // 本地导入 WordLocal
      handleChange(file, fileList) {

        // this.fileList = fileList.slice(-3)
        if (!/\.(doc|docx)$/.test(file.name)) {
          this.$messageError("文件类型必须是.doc,.docx中的一种");
          return false;
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        console.log(file)
        console.log(fileList)
        var fd = new window.FormData();
        fd.append("file", file);
        this.$api.apiAdmin.WordLocal1(fd).then(res => {
          this.content = this.content.replace(/body/g, "div") + res.replace(/body/g, "div")
          this.outDrBox = false
          loading.close();
        }).catch(res => {

          this.upActive = true
          this.content = this.content + res.replace(/body/g, "div")
          console.log(this.content)
          this.status = false
          // this.statesave = true
          // console.log(this.content)
          this.outDrBox = false
          loading.close();
        })

      },
      // 获取库和树
      getKu() {
        this.$api.apiAdmin.GetAllFile({
          // mid: this.user.mid
          mid: 'dHkyNmR0WWRIPW9QRHhGV0x0bWpo'
        }).then(res => {
          res.data.map(item => {
            item.label = item.name
            if (!item.filepath) {
              item.disabled = true
            }
          })
          this.zsgl = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 知识库树单选操作1
      resetChecked() {
        this.$refs.treeZsk.setCheckedKeys([]);
      },
      // 知识库树单选操作2
      handleCheckChange(data) {
        let arr = this.$refs.treeZsk.getCheckedNodes()
        if (arr.length > 1) {
          this.resetChecked()
          this.$refs.treeZsk.setChecked(data.id, true);
        }
      },
      // 监听滚动
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (this.scrollTop > 70) {
          // 设置滚动大于300时的执行内容
          var arr = document.getElementsByClassName('w-e-toolbar')
          arr[0].style.position = "fixed"
          arr[0].style.width = "700px"
          arr[0].style.top = "70"
          arr[0].style.zIndex = "1002"
          this.rightTrue = true
        }
        if (this.scrollTop < 70) {
          var ary = document.getElementsByClassName('w-e-toolbar');
          ary[0].style.position = "inherit"
          ary[0].style.width = "inherit"
          ary[0].style.top = "inherit"
          ary[0].style.zIndex = "inherit"
        }
        this.rightTrue = false

      },
      // 文章引用量+1
      yinYong(id) {
        this.$api.apiAdmin.useinfo({
          mid: this.user.mid,
          id: id
        }).then().catch()
      },
      //
      add(tex, id,type) {
        this.yinY = this.yinY + 1
        this.content = this.content + tex
        // this.yinY = false
        this.status = false
        // this.statesave = true
        this.$api.apiAdmin.useinfo({
          mid: this.user.mid,
          id: id,
          type:type
        }).then().catch()
      },
      // 获取我所有标签接口
      getMeSuoYBiaoq() {
        this.$api.apiAdmin.GetAllLable({
          mid: this.user.mid
        }).then(res => {
          this.suoYbiaoQList = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      //  获取模板文章详情
      Viemoban(id) {
        this.$api.apiAdmin.Viemoban({
          mid: this.user.mid,
          id: id
        }).then(res => {

          // this.guanjianzi = res.data.lable
          this.WZtitle = res.data.title
          this.content = res.data.content
          // this.content = `<div class="hzTit" style="font-size: 60px;color: red;">中国航天科工集团</div>`
          this.XuanZbiaoQList = res.data.label
          // this.AllBiaoqList = res.data.label
          if (res.data.label.length < 1) {
            this.hasBiaoq = false
          }
          this.beginSou()
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 预览的时候获取模板文章详情
      lyViemoban(id,type) {
        this.$api.apiAdmin.viewArticle({
          mid: this.user.mid,
          id: id,
          type:type
        }).then(res => {
          this.ylWZtitle = res.data.title
          this.ylcontent = res.data.content
          this.ylType = type
          this.XuanZbiaoQList = res.data.label
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      //  获取自己写的文章详情
      viewArticle() {
        this.$api.apiAdmin.viewArticle({
          mid: this.user.mid,
          id: this.id
        }).then(res => {
          this.WZtitle = res.data.title
          this.content = res.data.content
          // this.guanjianzi = res.data.lable
          this.XuanZbiaoQList = res.data.label
          this.AllBiaoqList = res.data.label
          this.sizeForm.region = res.data.folderid
          if (res.data.label.length < 1) {
            this.hasBiaoq = false
          }
          this.beginSou()
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 一进来就搜索
      beginSou() {
        this.TwoBoxShow = false
          this.ThreeBoxShow = true

        this.$api.apiAdmin.GetsystemArt({
          mid: this.user.mid,
          keyword: '',
          lable: this.guanjianzi,
          page: 1,
          pagesize: 9999
        }).then(res => {
          console.log(res)
          this.WzList = res.data.data
          if (res.data.data.length <= 0) {
            this.WzList = []
            this.hassucaiList = false
          } else {
            this.hassucaiList = true
          }
          // this.Wzlist.map(item=>{
          //   item.content = item.content.replace(/&nbsp;/g, "")
          // })
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 搜索出来的文章列表
      SousWZlist() {
        this.$api.apiAdmin.GetsystemArt({
          mid: this.user.mid,
          keyword: this.search,
          lable: this.souSlable,
          page: 1,
          pagesize: 9999
        }).then(res => {
          this.WzList = res.data.data
          if (res.data.data.length <= 0) {
            this.$messageSuccess("暂时没有寻找到你想要的数据");
            this.WzList = []
            this.hassucaiList = false
          } else {
            this.hassucaiList = true
          }
          // this.Wzlist.map(item=>{
          //   item.content = item.content.replace(/&nbsp;/g, "")
          // })
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 获取所有标签
      AllLableList() {
        this.$api.apiAdmin.AllLable({
          mid: this.user.mid
        }).then(res => {
          this.AllBiaoqList = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 取消弹框
      quXsave() {
        this.dialogVisible = false
        this.shengC = ''
      },

      // 保存弹框
      save(num) {
        console.log(Boolean(this.mbId))
        if (num == '999') {
          this.shengC = '999'
          this.tanTit = '模 板 保 存'
        } else {
          this.shengC = ''
          this.tanTit = '文 章 保 存'
        }
        // 获取内容
        if (this.content === '') {
          this.$messageError('请填写文章内容！');
          return false
        }
        if (this.WZtitle === '') {
          this.$messageError('请填写文章标题！');
          return false
        }
        this.dialogVisible = true
      },
      // 生成模板
      shengMuabn() {
        // alert('生成模板')
        if (this.XuanZbiaoQList.length > 0) {
          this.XuanZbiaoQList.map(item => {
            this.XuanZbiaoQianTexList.push(item.title)
            this.XuanZbiaoQianIDList.push(item.id)
          })
        }
        this.$api.apiAdmin.Addmoban({
          mid: this.user.mid,
          id: this.id,
          title: this.WZtitle,
          content: this.content,
          // folderid: this.sizeForm.region,
          lableid: this.XuanZbiaoQianIDList.join(','),
          lable: this.XuanZbiaoQianTexList.join(','),
        }).then(() => {
          this.dialogVisible = false
          this.WZtitle = ''
          this.content = ''
          // this.sizeForm.region = ''
          this.XuanZbiaoQianIDList = []
          this.XuanZbiaoQianTexList = []
          this.XuanZbiaoQList = []
          this.shengC = ''

          this.mubanAdd = true

          // this.statesave = false
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 编辑模板
      editMuabn() {
        if (this.XuanZbiaoQList.length > 0) {
          this.XuanZbiaoQList.map(item => {
            this.XuanZbiaoQianTexList.push(item.title)
            this.XuanZbiaoQianIDList.push(item.id)
          })
        }
        this.$api.apiAdmin.Editmoban({
          mid: this.user.mid,
          id: this.mbId,
          title: this.WZtitle,
          content: this.content,
          folderid: 0,
          lableid: this.XuanZbiaoQianIDList.join(','),
          lable: this.XuanZbiaoQianTexList.join(','),
        }).then(() => {

          this.dialogVisible = false
          this.WZtitle = ''
          this.content = ''
          // this.sizeForm.region = ''
          this.XuanZbiaoQianIDList = []
          this.XuanZbiaoQianTexList = []
          this.XuanZbiaoQList = []

          this.mubanAdd = true

          // this.statesave = false
          this.$router.go(-1);
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 确定保存
      qdSave() {
        if (this.sizeForm.region === '' && this.shengC !== '999') {
          this.$messageError('请选择文件夹！');
        } else {
          if (this.XuanZbiaoQList.length > 0) {
            this.XuanZbiaoQList.map(item => {
              this.XuanZbiaoQianTexList.push(item.title)
              this.XuanZbiaoQianIDList.push(item.id)
            })
          }
          if (this.id && this.shengchengWZ === '98') {
            // if(this.shengC === '999'){
            //   alert('生成模板')
            //
            // }else {
            //  alert('编辑')
            this.$api.apiAdmin.editArticle({
              mid: this.user.mid,
              id: this.id,
              title: this.WZtitle,
              content: this.content,
              folderid: this.sizeForm.region,
              lableid: this.XuanZbiaoQianIDList.join(','),
              lable: this.XuanZbiaoQianTexList.join(','),
            }).then(() => {
              this.dialogVisible = false
              this.WZtitle = ''
              this.content = ''
              this.sizeForm.region = ''
              this.XuanZbiaoQianIDList = []
              this.XuanZbiaoQianTexList = []
              this.XuanZbiaoQList = []
              // this.statesave = true
              this.wenzhangAdd = true
            }).catch(res => {
              this.$messageError(res.msg);
            })
            // }
          } else {
            this.$api.apiAdmin.addArticle({
              mid: this.user.mid,
              title: this.WZtitle,
              content: this.content,
              folderid: this.sizeForm.region,
              lableid: this.XuanZbiaoQianIDList.join(','),
              lable: this.XuanZbiaoQianTexList.join(','),
            }).then(() => {
              this.dialogVisible = false
              this.WZtitle = ''
              this.content = ''
              this.sizeForm.region = ''
              this.XuanZbiaoQianIDList = []
              this.XuanZbiaoQianTexList = []
              this.XuanZbiaoQList = []
              // this.statesave = true
              this.wenzhangAdd = true
            }).catch(res => {
              this.$messageError(res.msg);
            })
          }
        }
      },
      // 保存成功跳我的文章
      toWenzhang() {
        this.wenzhangAdd = false
        this.$router.push('/home/wdwzBanKuai')
      },
      // 生成模板跳我的模板
      toMuban() {
        this.mubanAdd = false
        this.$router.push('/home/mbzxBanKuai/zyMuBan')
      },
      // 自己添加标签
      tjBq() {
        if (this.sizeForm.name == '') {
          this.$messageError("请先输入标签名字！");
        } else {
          this.$api.apiAdmin.AddLable({
            mid: this.user.mid,
            title: this.sizeForm.name
          }).then(res => {
            this.XuanZbiaoQList.push({id: res.data, title: this.sizeForm.name})
            this.sizeForm.name = ''
            // 获取我所有标签接口
            this.getMeSuoYBiaoq()
          }).catch(() => {
            this.$messageError('您已经添加过这个标签了');
          })
        }
      },
      // 删除标签
      delBq(id, index) {
        this.$api.apiAdmin.DelLable({
          mid: this.user.mid,
          id: id
        }).then(res => {
          this.$messageSuccess(res.msg);
          this.XuanZbiaoQList.splice(Number(index), 1)
          this.XuanZbiaoQianTexList.splice(Number(index), 1)
          this.XuanZbiaoQianIDList.splice(Number(index), 1)
        }).catch(res => {
          this.$messageError(res.msg);
        })

      },
      // 从所有标签选标签
      addBq(id, title) {
        var stat = true
        this.XuanZbiaoQList.map(item => {
          if (Number(id) === Number(item.id)) {
            this.$messageError('您已经添加过这个标签了');
            stat = false
          }
        })
        if (stat) {
          this.XuanZbiaoQList.push({id: id, title: title})
        }
      },
      // 文件夹列表
      GetwjList() {
        this.$api.apiAdmin.GetFolderList({
          mid: this.user.mid
        }).then(res => {
          this.wjList = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 新建文件夹
      xj() {
        this.$prompt('<h3>新建文件夹</h3>', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'cjBtn',
          cancelButtonClass: 'qxBtn',
          center: true,
          dangerouslyUseHTMLString: true,
          roundButton: true,
          inputPattern: /\S/,
          inputErrorMessage: '名字不能为空'
        }).then(({value}) => {
          this.$api.apiAdmin.AddFolder({
            mid: this.user.mid,
            title: value
          }).then(res => {
            this.$messageSuccess(res.msg);
            // 文件夹列表
            this.GetwjList()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      // 复制功能
      copy(tex) {
        let clipBoardContent = tex
        let oInput = document.createElement('input')
        oInput.value = clipBoardContent
        document.body.appendChild(oInput)
        oInput.select() // 选择对象
        document.execCommand("Copy") // 执行浏览器复制命令
        oInput.className = 'oInput'
        oInput.style.display = 'none'
        this.$message({message: '复制成功', type: 'success'})
      },
      // 右边栏出来
      chu() {
        if (this.search !== '') {
          this.OneBoxShow = false
          this.TwoBoxShow = false
          this.ThreeBoxShow = true
          return false
        }
        this.OneBoxShow = false
        this.TwoBoxShow = true
        this.shengchengWZ = ''
      },
      // 右边栏收回去
      shou() {
        this.OneBoxShow = true
        this.TwoBoxShow = false
        this.ThreeBoxShow = false
      },
      // 搜索过渡
      jSou() {
        this.OneBoxShow = false
        this.TwoBoxShow = false
        this.ThreeBoxShow = true
        this.SousWZlist()
      },
      // 获取内容
      getData(data) {
        console.log(data)
        this.content = data
        this.upActive = false
      },
      // 预览
      yl(ylID,ylType) {
        this.ylID = ylID
        this.lyViemoban(ylID,ylType)
        this.status = true
      },
      // 详情关闭
      colse() {
        this.status = false
      },

      // goTo() {
      //   // 文章引用量+1
      //   this.yinYong()
      //   this.$router.push({
      //     path: '/home/zncgBanKuai',
      //     query: {
      //       id: this.ylID
      //     }
      //   })
      //   this.id = this.ylID
      //   this.status = false
      // },

    },
    components: {
      quill
    },
    watch: {
      id() {
        if (this.shengchengWZ !== '98' && this.id) {
          this.Viemoban(this.id)
        }
      },
      souSlable() {
        this.SousWZlist()
      },
      WZtitle() {
        if (this.WZtitle === '') {
          return false
        }
        this.titNum = this.WZtitle.length
      },
      content() {
        var tex = '';
        tex = this.content
        tex = this.$tools.removeWordXml(tex)
        console.log(tex)
        this.conNum = tex.length
      }
    }
  }
</script>

<style scoped lang="scss">
  .jia {
    cursor: pointer;
  }

  .fixd {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    /*width: 44% !important;*/
  }

  .yxBox {
    min-height: 40px;
    padding-bottom: 10px;
  }

  .l-animate {
    transition: all 1s ease;
  }

  .l-move {
    transform: translateX(-500px);
  }

  .bqact {
    background-color: #0a2240 !important;
    color: #ffffff !important;
  }

  .box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    overflow: hidden;

    .boxLeft {
      width: 96%;
      height: 100%;
      overflow: hidden;

      .leftSc {
        width: 102%;
        height: 100%;
        /*overflow-y: scroll;*/
        display: flex;
        justify-content: center;

        .bjq {
          width: 770px;
          min-height: 97%;
          height: 97%;
          /*height: -webkit-fill-available;*/
          background-color: #ffffff;
          position: relative;

          .titnum {
            position: absolute;
            top: 30px;
            right: 0px;
            font-size: 14px;
          }

          .btinp {
            position: absolute;
            left: 48px;
            top: 50px;
            right: 45px;
            border-bottom: 1px solid #999;
            z-index: 1001;

            input {
              font-size: 28px;
              font-weight: bold;
              padding-bottom: 10px;
            }
          }

          .caoz {
            position: absolute;
            bottom: 10%;
            right: -160px;

            .save {
              width: 140px;
              height: 46px;
              background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
              linear-gradient(
                  #ffffff,
                  #ffffff);
              background-blend-mode: normal,
              normal;
              box-shadow: -1px 1px 5px 0px rgba(163, 163, 163, 0.45);
              border-radius: 23px;
              line-height: 46px;
              margin-bottom: 20px;
              font-size: 16px;
              color: #fff;
              font-weight: bold;
              cursor: pointer;
            }
            .shengC{
              width: 140px;
              height: 46px;
              background:#fff;
              box-shadow: -1px 1px 5px 0px rgba(163, 163, 163, 0.45);
              border-radius: 23px;
              line-height: 46px;
              margin-bottom: 20px;
              font-size: 16px;
              color: #0a2240;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }


    }

    .boxRight {
      width: 4%;
      height: -webkit-fill-available;
      /*top: 0;*/
      /*bottom: 0;*/
      background-color: rgba(255, 255, 255, .4);
      box-shadow: -6px 6px 24px 0px rgba(199, 199, 199, 0.5);
      /*overflow: hidden;*/
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      position: fixed;
      top: 150px;
      bottom: 0;
      right: 0;

      .btn {
        position: absolute;
        width: 21px;
        height: 84px;
        background-color: #0a2240;
        border-radius: 10px 0px 0px 10px;
        line-height: 84px;
        color: #fff;
        text-align: center;
        left: -21px;
        top: 42%;
        cursor: pointer;
      }

      .btnTwo {
        position: absolute;
        width: 21px;
        height: 84px;
        background-color: #999999;
        border-radius: 0px 10px 10px 0px;
        line-height: 84px;
        color: #fff;
        text-align: center;
        left: 0px;
        top: 42%;
        cursor: pointer;
      }

      .wjz {
        width: 41px;
        margin-top: 30px;

        img {
          width: 25px;
          height: 26px;
          margin-left: 8px;
        }

        .tex {
          width: 100%;
          text-align: center;
          margin-top: 1px;
          color: #0a2240;
          font-size: 14px;
        }
      }

      .rBox {
        width: 80%;
        margin-top: 50px;

        h3 {
          font-size: 18px;
          color: #0a2240;
          margin-bottom: 30px;
        }

        .souS {
          width: 100%;
          margin-top: 30px;
          text-align: center;

          button {
            width: 100px;
            height: 30px;
            cursor: pointer;
            background: #0a2240 url("../../../assets/images/sousuo.png") no-repeat left center;
            background-size: 18px 18px;
            background-position-x: 16px;
            box-shadow: -6px 6px 18px 0px rgba(255, 170, 170, 0.45);
            border-radius: 15px;
            border: none;
            color: #ffffff;
            font-size: 14px;
            padding-left: 20px;
          }
        }

        .inp {
          width: 100%;

          input {
            width: 98%;
            height: 30px;
            background-color: #fff;
            border-radius: 24px;
            line-height: 31px;
            border: none;
            padding-left: 15px;
          }
        }
      }

      .tBox {
        width: 88%;
        margin-top: 50px;

        .tBoxTop {
          width: 100%;
          display: flex;
          justify-content: center;
          position: relative;

          .ssBtn {
            width: 93px;
            height: 30px;
            background-image: linear-gradient(37deg,
              #ffb400 0%,
              #fc7802 100%),
            linear-gradient(
                #a01212,
                #a01212);
            background-blend-mode: normal,
            normal;
            border-radius: 23px;
            font-size: 14px;
            //background: url('../../../assets/images/souS.png') no-repeat left center;
            //background-size: 14px;
            position: absolute;
            top: 0;
            right: 30%;
            cursor: pointer;
            color: #fff;
            img{
              width: 20px;
            }
          }

          input {
            height: 30px;
            border-radius: 15px;
            //border: solid 1px #0a2240;
            width: 83%;
            margin-right: 1%;
            padding-left: 10px;
            padding-right: 60px;
            box-sizing: border-box;
          }

          button {
            height: 30px;
            border-radius: 15px;
            border: solid 1px #0a2240;
            width: 36%;
            color: #fff;
            background-color: #0a2240;
          }
        }

        .biaoQ {
          width: 100%;
          margin-top: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #d9d9d9;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          .s1 {
            font-size: 12px;
            color: #000;
            margin-right: 5px;
            margin-top: 5px;
          }

          .s2 {
            font-size: 12px;
            color: #333;
            margin-right: 5px;
            padding: 2px 8px;
            border-radius: 10px;
            background-color: #f2f2f2;
            cursor: pointer;
            margin-top: 5px;
          }
        }

        .WzBox {
          width: 112%;
          padding-right: 9%;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          height: calc(100vh - 420px);
          overflow-y: scroll;
          padding-bottom: 100px;

          .wenZ {
            width: 98%;
            /*margin-left: 1%;*/
            height: 300px;
            margin-top: 20px;
            background-color: #ffffff;
            /*box-shadow: -3px 3px 12px 0px rgba(199, 199, 199, 0.5);*/
            box-shadow: -2px 2px 8px 0px rgba(199, 199, 199, 0.5);
            border-radius: 10px;

            .wzTop {
              width: 100%;

              display: flex;
              justify-content: space-between;

              .wzTopLeft {
                width: 10%;
                text-align: center;
                margin-top: 90px;

                .s3 {
                  font-size: 10px;
                  color: #333333;
                  /* padding: 2px 8px; */
                  width: 40px;
                  height: 18px;
                  line-height: 18px;
                  text-align: center;
                  border-radius: 10px;
                  background-color: #ffd919;
                  margin-left: 5px;
                  cursor: pointer;
                  /* margin-top: 100px; */
                  display: block;
                  margin-top: 40px;
                }

                img {
                  width: 14px;
                  height: 14px;
                }

                div {
                  width: 100%;
                  text-align: center;
                  margin-top: 5px;
                  font-size: 12px;
                  color: #0a2240;
                }
              }

              .wzTopRight {
                width: 90%;
                height: 240px;
                margin-top: 10px;
                /*overflow-y: scroll;*/
                /*overflow-x: hidden;*/

                div {
                  font-size: 12px;
                  width: 100%;
                  overflow: scroll;
                  height: 100%;

                  p {
                    width: 100%;
                    word-wrap: break-word;
                    word-break: break-all;

                    span {
                      position: initial !important;
                      z-index: initial !important;
                      margin-left: 0 !important;
                      width: 100% !important;
                      height: initial !important;
                    }
                  }
                }
              }
            }

            .wzBottom {
              width: 100%;
              display: flex;
              justify-content: flex-end;
              box-sizing: border-box;
              padding-right: 30px;
              margin-top: 10px;

              .s1 {
                font-size: 10px;
                color: #999999;
                padding: 2px 8px;
                border-radius: 10px;
                border: 1px solid #999999;
                cursor: pointer;
              }

              .s2 {
                font-size: 10px;
                color: #0a2240;
                padding: 2px 8px;
                border-radius: 10px;
                border: 1px solid #0a2240;
                margin-left: 5px;
                cursor: pointer;
              }


            }
          }
        }
      }
    }

    .conit {
      width: 100%;
      background-color: #fff;

    }

    .title {
      width: 600px;
      margin-left: 50px;
      font-size: 28px;
      font-weight: bold;
      color: #333333;
      border-bottom: 2px solid #d4d6da;
      text-align: center;
      padding: 10px 0;
    }

    .conte {
      margin-top: 30px;
      width: 600px;
      height: 76vh;
      margin-left: 50px;
      overflow: scroll;
    }

    .btn {
      position: absolute;
      top: 30px;
      right: -90px;

      .qdBtn {
        width: 110px;
        height: 38px;
        background-color: #0a2240;
        box-shadow: -1px 1px 5px 0px rgba(204, 59, 59, 0.45);
        border-radius: 19px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
      }

      .qXBtn {
        width: 110px;
        height: 38px;
        background-color: #ffffff;
        box-shadow: -1px 1px 5px 0px rgba(204, 59, 59, 0.45);
        border-radius: 19px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        color: #333;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
</style>
